import type { ExportCell } from '../export.types';

/** Text of an optional string field (anything else is an empty cell). */
export const textCell = (value: unknown): string => (typeof value === 'string' ? value : '');

/** Value of an optional numeric field (anything else is an empty cell). */
export const numberCell = (value: unknown): ExportCell =>
  typeof value === 'number' && !Number.isNaN(value) ? value : '';

/** First of the given values that is a number. */
export const firstNumber = (...values: unknown[]): ExportCell => {
  const found = values.find((value): value is number => typeof value === 'number' && !Number.isNaN(value));
  return found ?? '';
};

export const GROUP_SEPARATOR = '; ';
